import "./js/util/stripe"; // side effect so loaded after page load https://stripe.com/docs/disputes/prevention/advanced-fraud-detection
import "./index.css";

import App from "./js/App.vue";
import { ENVIRONMENT } from "./js/util/environment";
import PortalVue from "portal-vue";
import ROUTES from "./js/router/routes";
import { Store } from "./js/plugins/valtio/store";
import Vue from "vue";
import VueApollo from "vue-apollo";
import VueRouter from "vue-router";
import { VuePlugin as Vuera } from "@landtechnologies/vuera";
import deckPlugin from "./js/plugins/deck.gl";
import { drawingStore } from "./js/stores/drawing/store";
import { i18n } from "./js/i18n";
import { initialiseApolloProvider } from "./js/util/apollo";
import { initialiseMemoryUsageTracking } from "./js/util/trackMemoryUsage";
import { letterStore } from "./js/stores/letter/store";
import { mapStore } from "./js/stores/map/store";
import { navigationStore } from "./js/stores/navigation/store";
import { osMapPrintStore } from "./js/stores/osMapPrint/store";
import { editorStore } from "./js/stores/editor/store";
import { router } from "./js/router/router";
import { searchStore } from "./js/stores/search/store";
import { setAccountsServiceProvider } from "./js/util/user";
import { siteFiltersStore } from "react-migration/domains/sites/pipeline/filters/SiteFiltersStore/store";
import { siteGeometryStore } from "./js/stores/siteGeometry/store";
import { siteStore } from "./js/stores/site/store";
import { sitesPipelineStore } from "./react-migration/domains/sites/pipeline/store/store";
import { userStore } from "./js/stores/user/store";
import valtioPlugin from "./js/plugins/valtio";

initialiseMemoryUsageTracking();

Vue.use(VueRouter);
Vue.use(VueApollo);
Vue.use(PortalVue);
Vue.use(deckPlugin);
Vue.use(valtioPlugin);
Vue.use(Vuera);

const apolloProvider = initialiseApolloProvider({
  graphqlGatewayUrl: ENVIRONMENT.GRAPHQL_GATEWAY_URL,
  constraintsApiUrl: ENVIRONMENT.CONSTRAINTS_API_URL,
  loginUrl: ENVIRONMENT.LOGIN_URL,
  appEnv: ENVIRONMENT.APP_ENV,
  accountsServicePrivateApiUrl: ENVIRONMENT.ACCOUNTS_SERVICE_PRIVATE_API_URL,
  planningServiceUrl: ENVIRONMENT.PLANNING_SERVICE_V2_URL_EXTERNAL,
});

setAccountsServiceProvider(apolloProvider.clients.accountServicePrivateApi);

const app = new Vue({
  i18n,
  router,
  el: "#app",
  components: { App },
  apolloProvider,
  beforeCreate: function () {
    window.A = this;
  },
  // @ts-expect-error - currently in js
  store: new Store({
    mapStore,
    drawingStore,
    siteGeometryStore,
    userStore,
    osMapPrintStore,
    siteStore,
    editorStore,
    letterStore,
    sitesPipelineStore,
    searchStore,
    siteFiltersStore,
    navigationStore,
  }),
  provide: function () {
    return {
      routes: ROUTES,
    };
  },
  render(createElement) {
    return createElement("app");
  },
});

setTimeout(async () => {
  const sw = await import(
    /* webpackChunkName: 'serviceworker-window' */
    /* webpackPrefetch: true */
    // @ts-expect-error yes - we do want to import a .ts extension - it is compiled by webpack....  shutup typescript interpreter
    "./js/service-worker-window.ts"
  );
  sw.init();
}, 20000);

window.APP = app; // for debug purposes
